import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { ListResponse, PaginationDto } from "../../interfaces";
import { Chat, ChatBatch, Message } from "../../interfaces/chat.interface";
import { EditMessageDto, GetMessagesDto, SendMessageDto } from "../../interfaces/dto/chat.dto";

export const chatApi = createApi({
  reducerPath: "chatApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/chat",
    credentials: "include",
  }),
  tagTypes: ["Messages", "ChatBatches"],
  endpoints: (build) => ({
    getChatBatches: build.query<ListResponse<ChatBatch>, Partial<PaginationDto>>({
      query: (params) => ({
        url: "/batches",
        method: "GET",
        params,
      }),
      providesTags: ["ChatBatches"],
    }),

    getMessages: build.query<ListResponse<Message>, Partial<GetMessagesDto>>({
      query: (params) => ({
        url: "/messages",
        method: "GET",
        params,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        if (arg.skip !== 0) return;
        try {
          await queryFulfilled;
          // After fetching messages, invalidate chat batches so unread count updates
          dispatch(chatApi.util.invalidateTags(["ChatBatches"]));
        } catch (err) {
          // handle error
        }
      },

      providesTags: ["Messages"],
    }),

    sendMessage: build.mutation<Message, SendMessageDto>({
      query: (body) => ({
        url: "/messages",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ChatBatches"],
    }),

    deleteMessage: build.mutation<{ message: string }, { id: string }>({
      query: ({ id }) => ({
        url: "/messages",
        method: "DELETE",
        body: { id },
      }),
      // invalidatesTags: ["ChatBatches"],
    }),

    editMessage: build.mutation<{ message: string }, EditMessageDto>({
      query: (body) => ({
        url: "/messages",
        method: "PUT",
        body,
      }),
      // invalidatesTags: ["ChatBatches"],
    }),

    updateChat: build.mutation<Chat, { batch_id: string; is_active: boolean }>({
      query: (body) => ({
        url: "/",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ChatBatches"],
    }),
    deleteChat: build.mutation<Chat, { chat_id: string }>({
      query: (body) => ({
        url: "/",
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["ChatBatches"],
    }),
  }),
});

export const {
  useGetMessagesQuery,
  useLazyGetMessagesQuery,
  useSendMessageMutation,
  useGetChatBatchesQuery,
  useUpdateChatMutation,
  useDeleteChatMutation,
  useDeleteMessageMutation,
  useEditMessageMutation,
} = chatApi;
